import React from 'react';
import ReactDOM from 'react-dom';
import { withI18n } from 'react-i18next';

type Props = {
  t: any;
  documentTitle?: string;
};

const titleNode = document.getElementsByTagName('title')[0];
titleNode.innerText = '';

const Title: React.FC<Props> = ({
  t,
  documentTitle
}) => {
  return ReactDOM.createPortal(
    documentTitle || t('Casting Kiosk'),
    titleNode
  );
};

export default withI18n()(Title);
